import {Location} from 'history';
import {jwtDecode} from 'jwt-decode';
import get from 'lodash-es/get';
import queryString from 'query-string';

import {SEARCH_PARAM_CREDENTIALS} from '@common/constants/authentication/authenticationConstants';
import {MainJwtPayload, JwtScope} from '@common/types/authentication/authentication.types';
import {NavigateFunction} from 'react-router-dom';
import {StsCredentials} from '@common/types/aws/aws.types';

export const persistMainJwtToStorage = (mainJwt: string) => sessionStorage.setItem('mainJwt', mainJwt);
export const persistScopedJwtToStorage = (scope: string | number, scopedJwt: string) => sessionStorage.setItem(`scopedJwt-${scope}`, scopedJwt);

export const getMainJwtFromStorage = () => sessionStorage.getItem('mainJwt');
export const getMainJwtFromUrl = (location: Location) => get(queryString.parse(get(location, 'search')), SEARCH_PARAM_CREDENTIALS);

export const cleanCredentialsFromUrl = (location: Location, navigate: NavigateFunction) => {
  const queryParams = new URLSearchParams(location.search);
  if (queryParams.has(SEARCH_PARAM_CREDENTIALS)) {
    queryParams.delete(SEARCH_PARAM_CREDENTIALS);
    navigate({
      search: queryParams.toString()
    });
  }
};

export const getScopedJwtFromStorage = (scope: JwtScope['scope']) => sessionStorage.getItem(`scopedJwt-${scope}`);
export const getMainJwt = (location: Location) => getMainJwtFromStorage() || getMainJwtFromUrl(location);
export const getScopedJwt = (scope: JwtScope['scope']) => getScopedJwtFromStorage(scope);

export const extractStsCredentialsFromMainJwt = (mainJwt: string): StsCredentials => {
  const sts = decodeJwt(mainJwt)?.data?.sts;
  return {
    accessKeyId: sts?.accessKeyId || '',
    secretAccessKey: sts?.secretAccessKey || '',
    sessionToken: sts?.sessionToken || undefined
  };
};

export const clearMainJwtFromStorage = () => sessionStorage.removeItem('mainJwt');
export const clearScopedJwtFromStorage = (scope: string | number) => sessionStorage.removeItem(`scopedJwt-${scope}`);

export const decodeJwt = (jwt: string): MainJwtPayload => jwtDecode<MainJwtPayload>(jwt);

export const isExpired = (expiry: number) => Date.now() / 1000 > expiry;

export const checkJwt = (jwt: string) => {
  const decodedJwt = decodeJwt(jwt);
  const expiry = get(decodedJwt, 'exp');
  return !!(expiry && !isExpired(expiry));
};
